import service from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const getPurchasedTicketPassengersService = (dID) => {
    return service.get(`/ticket-passenger/purchasedTicketPassengers/${dID}`, { params: getModelTypeIDAndEntityID() });
};

export const checkInOutPassengerService = (id, data) => {
    return service.put(`/ticket-passenger/checkin/${id}`, data);
};

export const printPurchasedTicketPassengersService = (dID) => {
    return service.get(`/ticket-passenger/printPurchasedTicketPassengers/${dID}`, {
        params: getModelTypeIDAndEntityID(),
        responseType: 'arraybuffer',
    });
};
